import React from "react";
import {
    makeStyles,
    Grid, Typography, TextField,
} from '@material-ui/core';
import { pxToRem, breakpoints } from '../../../../UIComponent/CommonStyle'

const useStyles = makeStyles((theme) => ({
    disabled: {
        color: '#000'
    },
    root: {
        display: 'flex-direction',
        flexWrap: 'wrap',
    },
    container: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    employeeName: {
        fontSize: 16,
        fontWeight: 600,
        color: '#3F51B5'
    },
    formSubtitle: {
        marginBottom: theme.spacing(1),
        fontSize: pxToRem(14),
        [breakpoints.up("md")]: {
            fontSize: pxToRem(16)
        }
    },
    textField: {
        marginBottom: theme.spacing(1),
    },
    inputField: {
        height: 6
    },
}));

export default function UserProfile({
    employeeName,
    managerName,
    staffNo,
    position,
    mail,
    staffDuty,
    entryDate,
    active,
    location,
    department,
}) {
    const classes = useStyles();
    const values = {
        employeeName: employeeName,
        managerName: managerName,
        staffNo: staffNo,
        position: position,
        mail: mail,
        staffDuty: staffDuty,
        entryDate: entryDate,
        active: active,
        location: location,
        department: department,
    };

    return (
        <div>
            <form className={classes.root} noValidate autoComplete="off">
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Typography className={classes.employeeName}>
                            {values.employeeName}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h5" component="h2" className={classes.formSubtitle}>
                            Position
                        </Typography>
                        <TextField fullWidth
                            id="position"
                            defaultValue={values.position}
                            className={classes.textField}
                            variant="outlined"
                            InputProps={{ classes: { input: classes.inputField, disabled: classes.disabled } }}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h5" component="h2" className={classes.formSubtitle}>
                            Staff Duty
                        </Typography>
                        <TextField fullWidth
                            id="staffDuty"
                            defaultValue={values.staffDuty}
                            className={classes.textField}
                            variant="outlined"
                            InputProps={{ classes: { input: classes.inputField, disabled: classes.disabled } }}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h5" component="h2" className={classes.formSubtitle}>
                            Location
                        </Typography>
                        <TextField fullWidth
                            id="location"
                            defaultValue={values.location}
                            className={classes.textField}
                            variant="outlined"
                            InputProps={{ classes: { input: classes.inputField, disabled: classes.disabled } }}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h5" component="h2" className={classes.formSubtitle}>
                            Department
                        </Typography>
                        <TextField fullWidth
                            id="department"
                            defaultValue={values.department}
                            className={classes.textField}
                            variant="outlined"
                            InputProps={{ classes: { input: classes.inputField, disabled: classes.disabled } }}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h5" component="h2" className={classes.formSubtitle}>
                            Manager
                        </Typography>
                        <TextField fullWidth
                            id="managerName"
                            defaultValue={values.managerName}
                            className={classes.textField}
                            variant="outlined"
                            InputProps={{ classes: { input: classes.inputField, disabled: classes.disabled } }}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h5" component="h2" className={classes.formSubtitle}>
                            Number
                        </Typography>
                        <TextField fullWidth
                            id="staffNo"
                            defaultValue={values.staffNo}
                            className={classes.textField}
                            variant="outlined"
                            InputProps={{ classes: { input: classes.inputField, disabled: classes.disabled } }}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h5" component="h2" className={classes.formSubtitle}>
                            Mail
                        </Typography>
                        <TextField fullWidth
                            id="mail"
                            defaultValue={values.mail}
                            className={classes.textField}
                            variant="outlined"
                            InputProps={{ classes: { input: classes.inputField, disabled: classes.disabled } }}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h5" component="h2" className={classes.formSubtitle}>
                            Join Date
                        </Typography>
                        <TextField fullWidth
                            id="entryDate"
                            defaultValue={values.entryDate}
                            className={classes.textField}
                            variant="outlined"
                            InputProps={{ classes: { input: classes.inputField, disabled: classes.disabled } }}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h5" component="h2" className={classes.formSubtitle}>
                            Status
                        </Typography>
                        <TextField fullWidth
                            id="status"
                            defaultValue={values.active}
                            className={classes.textField}
                            variant="outlined"
                            InputProps={{ classes: { input: classes.inputField, disabled: classes.disabled } }}
                            disabled
                        />
                    </Grid>
                </Grid>
            </form>
        </div >
    );
}
